/** Components */
import RegisterForm from './RegisterForm';
/** Styles */
import styles from 'styles/pages/StartPage.module.scss';

const Register = () => {
  return (
    <>
      <div className={styles.delicoffeStart}>
        <main className={styles.main}>
          <div className={styles.wrapper}>
            <RegisterForm />
          </div>
        </main>
      </div>
    </>
  );
};

export default Register;
